import { Injectable } from '@angular/core';
import { BlocklyHelpRegistry } from '@shared/blockly/core/help-registry';
import { handbookChannelForHostname } from '@shared/documentation/handbook-url';

export type { BlocklyHelpEntry, ResolvedBlockHelp } from '@shared/blockly/core/help-registry';

@Injectable({
  providedIn: 'root'
})
export class BlocklyHelpRegistryService extends BlocklyHelpRegistry {
  constructor() {
    super(handbookChannelForHostname(window.location.hostname));
  }
}
